import React, { useState, useEffect } from 'react';
import styles from '../assets/css/ScrollToTopButton.module.css';
import { FaChevronUp } from 'react-icons/fa';

function ScrollToTopButton() {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.scrollY > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <button
            className={`${styles.scroll_to_top_button} ${isVisible ? styles.visible : ''}`}
            onClick={scrollToTop}
        >
            <FaChevronUp />
        </button>
    );
}

export default ScrollToTopButton;